<template>
  <v-app>
    <v-main>
      <TotemAssistanceActions />
      <router-view />
      <!-- Modal global de aviso (substitui o alert() bloqueante). Fica aqui, no
           wrapper real da aplicação: `views/root.vue`, onde estava antes, não é
           usado por nenhuma rota, então o modal nunca chegava a ser montado. -->
      <vModalComponent />
    </v-main>
  </v-app>
</template>

<script>
document.addEventListener("contextmenu", (event) => event.preventDefault());

const ROTAS_SEM_ESCALA_CABINE = [
  "editorDeFotos",
  "aguardandoUpload",
  "agradecimento",
  "manutencao",
];

import vModalComponent from "@/components/vModalComponent";
import TotemAssistanceActions from "@/components/assistance/TotemAssistanceActions.vue";
import { marcarBootConcluido } from "@/kioskWatchdog";
import { prefetchTotemProducts } from "@/service/totemProducts";

export default {
  name: "App",
  components: {
    TotemAssistanceActions,
    vModalComponent,
  },
  watch: {
    $route: "aplicarEscalaCabine",
  },
  mounted() {
    // Avisa o watchdog que o boot deu certo — desarma o timer de tela
    // branca (ver src/kioskWatchdog.js).
    marcarBootConcluido();
    this.aplicarEscalaCabine();
    prefetchTotemProducts();
  },
  methods: {
    aplicarEscalaCabine() {
      const name = this.$route?.name;
      const path = this.$route?.path ?? "";
      const semEscala = ROTAS_SEM_ESCALA_CABINE.includes(name);
      const ehCabine = path.startsWith("/cabine");
      const deveEscalar = ehCabine && !semEscala;
      document.documentElement.classList.toggle(
        "cabine-viewport-scale",
        !!deveEscalar
      );
    },
  },
};
</script>

<style lang="scss">
body {
  font-family: "Rubik", sans-serif;
  margin: 0px;
  padding: 0px;
}
/*
*::-webkit-scrollbar {
  background-color: #fff;
  width: 16px;
}

*::-webkit-scrollbar-track {
  background-color: #fff;
}

*::-webkit-scrollbar-thumb {
  background-color: #babac0;
  border-radius: 16px;
  border: 4px solid #fff;
}

*::-webkit-scrollbar-button {
  display: none;
}
*/
</style>
